
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PushparentQuestionBankService } from '../../shared/services/push-parent-question-bank/push-parent-question-bank.service';
import * as moment from 'moment';
import { first } from 'rxjs/operators';


@Component({
  selector: 'app-push-parent-question-bank-list',
  templateUrl: './push-parent-question-bank-list.component.html',
  styleUrls: ['./push-parent-question-bank-list.component.scss']
})
export class PushParentQuestionBankListComponent implements OnInit {


  questionBank: any;

  filter: any = {
    key: ''
  };
  pushqbList: any = [];

  pageSize = 3;
  currentPage = 1;
  pushqbCount = 0;

  constructor(
    private router: Router,
    private pushparentQbApi: PushparentQuestionBankService

  ) { }

  ngOnInit() {

    this.searchParentQb();

  }


  onClick() {
    this.router.navigate(['manager/push-parent-question-bank/new']);
  }

  open(temp) {
    this.router.navigate(['manager/push-parent-question-bank/' + temp._id]);
  }

  searchParentQb() {
    this.pushparentQbApi.searchParentQb(this.currentPage, this.pageSize, this.filter)
    .pipe(first())
    .subscribe(res => {
      this.pushqbCount = res['count'];
      this.pushqbList = res['data'];

    });
  }

  fetchparentqb(e) {
    this.currentPage = e;

    this.searchParentQb();

  }
  
  clear() {
    this.filter.key = "";
    this.searchParentQb();
  }
}
